// Ecommerce dataLayer events for GTM (mm_* names that the GTM triggers listen for) and Klaviyo "Added to Cart".
// Page data comes from #AnalyticsConfig in snippets/tracking.liquid.

(function () {
  const configElement = document.getElementById('AnalyticsConfig');
  if (!configElement || window.analyticsLoaded) return;
  window.analyticsLoaded = true;

  const config = JSON.parse(configElement.textContent);
  const EVENT_PREFIX = 'mm_';
  const CART_URL = /\/cart\/(add|change|update)/;
  const CHECKOUT_SELECTOR =
    'input[name="checkout"], button[name="checkout"], a[href$="/checkout"], .additional-checkout-buttons';

  let cart = config.cart;
  window.dataLayer = window.dataLayer || [];

  // --- Formatting ---

  const toAmount = (cents) => +(cents / 100).toFixed(2);

  function formatItem(item, index) {
    const formatted = {
      item_id: `shopify_${config.countryCode}_${item.product_id}_${item.variant_id}`,
      variant_id: String(item.variant_id),
      item_name: item.product_title,
      quantity: item.quantity,
      price: toAmount(item.final_price),
      discount: item.total_discount ? toAmount(item.total_discount) : 0,
    };
    if (index !== undefined) formatted.index = index;
    if (item.product_type) formatted.item_category = item.product_type;
    if (item.vendor) formatted.item_brand = item.vendor;
    if (item.variant_title && item.variant_title !== 'Default Title') formatted.item_variant = item.variant_title;
    if (item.sku) formatted.sku = item.sku;
    if (item.item_list_id) formatted.item_list_id = item.item_list_id;
    if (item.item_list_name) formatted.item_list_name = item.item_list_name;
    return formatted;
  }

  // --- dataLayer ---

  function pushEcommerce(event, ecommerce) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: EVENT_PREFIX + event, ecommerce: { currency: cart.currency, ...ecommerce } });
  }

  function pushItem(event, item) {
    pushEcommerce(event, {
      value: +((item.final_price / 100) * item.quantity).toFixed(2),
      items: [formatItem(item)],
    });
  }

  function pushItems(event, list) {
    const ecommerce = { items: list.items.map(formatItem) };
    if (list.total_price) ecommerce.value = toAmount(list.total_price);
    if (list.item_list_id) ecommerce.item_list_id = list.item_list_id;
    if (list.item_list_name) ecommerce.item_list_name = list.item_list_name;
    pushEcommerce(event, ecommerce);
  }

  // --- Klaviyo ---

  function trackKlaviyoAddedToCart() {
    window._learnq = window._learnq || [];
    window._learnq.push([
      'track',
      'Added to Cart',
      {
        total_price: toAmount(cart.total_price),
        $value: toAmount(cart.total_price),
        total_discount: cart.total_discount,
        original_total_price: toAmount(cart.original_total_price),
        items: cart.items,
      },
    ]);
  }

  // --- Cart requests ---
  // fetch and XHR are both watched so adds from apps (Nosto, PreProduct) are tracked as well as the theme's own.

  function refreshCart() {
    return originalFetch(`${window.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((data) => (cart = data));
  }

  function diffCart(newCart) {
    cart.items.forEach((item) => {
      const newItem = newCart.items.find((candidate) => candidate.key === item.key);
      const newQuantity = newItem ? newItem.quantity : 0;
      if (newQuantity === item.quantity) return;
      const event = newQuantity > item.quantity ? 'add_to_cart' : 'remove_from_cart';
      pushItem(event, { ...item, quantity: Math.abs(newQuantity - item.quantity) });
    });
  }

  function onResponse(url, data) {
    if (url.includes('/cart/add')) {
      (data.items || [data]).forEach((item) => pushItem('add_to_cart', item));
      refreshCart().then(trackKlaviyoAddedToCart);
    } else if (data.items) {
      diffCart(data);
      cart = data;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function (input) {
    const request = originalFetch.apply(this, arguments);
    const url = input instanceof Request ? input.url : String(input);
    if (CART_URL.test(url)) {
      request
        .then((response) => (response.ok ? response.clone().json() : null))
        .then((data) => data && onResponse(url, data))
        .catch(() => {});
    }
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    const requestUrl = String(url);
    if (CART_URL.test(requestUrl)) {
      this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 400) return;
        try {
          const data = this.responseType === 'json' ? this.response : JSON.parse(this.responseText || '{}');
          onResponse(requestUrl, data || {});
        } catch (error) {}
      });
    }
    return originalOpen.apply(this, arguments);
  };

  // --- Page views ---

  if (config.product) pushItem('view_item', config.product.item);
  if (config.collection) pushItems('view_item_list', config.collection);
  if (config.template === 'cart') pushItems('view_cart', cart);

  const pageSearchTerm = new URLSearchParams(window.location.search).get('q');
  const navigation = performance.getEntriesByType('navigation')[0];
  if (config.template === 'search' && pageSearchTerm && (!navigation || navigation.type === 'navigate')) {
    window.dataLayer.push({ event: EVENT_PREFIX + 'view_search_results', search_term: pageSearchTerm });
  }

  // --- Clicks ---

  // ReConvert re-dispatches its own click on the checkout button, so one press can arrive twice.
  let lastCheckoutClick = 0;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('#cart-icon-bubble')) pushItems('view_cart', cart);
    if (event.target.closest(CHECKOUT_SELECTOR) && event.timeStamp - lastCheckoutClick > 1000) {
      lastCheckoutClick = event.timeStamp;
      pushItems('begin_checkout', cart);
    }

    // Cards added by Load More aren't in the page config, so they're skipped.
    const cardLink = config.collection && event.target.closest('product-card a[href*="/products/"]');
    if (cardLink) {
      const productId = Number(cardLink.closest('product-card').dataset.productId);
      const index = config.collection.items.findIndex((item) => item.product_id === productId);
      if (index !== -1) {
        pushEcommerce('select_item', {
          item_list_id: config.collection.item_list_id,
          item_list_name: config.collection.item_list_name,
          items: [formatItem(config.collection.items[index], index)],
        });
      }
    }
  });

  // Dynamic checkout (Buy it now) skips the cart, so it counts as add_to_cart + begin_checkout.
  document.addEventListener('pointerdown', (event) => {
    if (!config.product || !(event.target instanceof Element)) return;
    const form = event.target.closest('.shopify-payment-button')?.closest('form[action*="/cart/add"]');
    if (!form) return;

    const variantId = Number(form.querySelector('input[name="id"]')?.value);
    const variant = config.product.variants.find((candidate) => candidate.id === variantId);
    if (!variant) return;

    const quantityInput = form.id && document.querySelector(`input[name="quantity"][form="${form.id}"]`);
    const item = {
      ...config.product.item,
      variant_id: variant.id,
      variant_title: variant.title,
      final_price: variant.price,
      sku: variant.sku,
      quantity: quantityInput ? Number(quantityInput.value) || 1 : 1,
    };
    pushItem('add_to_cart', item);
    pushItem('begin_checkout', item);
  });
})();
